(() => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const navigation = document.querySelector('[data-mobile-nav]');
  if (toggle && navigation) {
    toggle.addEventListener('click', () => {
      const open = navigation.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    });
  }
})();
